import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonsealService {

  constructor( private httpService: HttpService) { }


  addCommonSealData(object) {

    var request = {
      URL: "commonSeal/addCommonSealDetails",
      DATA: object
    }
    return this.httpService.post(request)
  }

  getCommonSealList(object) {
    var registerList = {
      URL: "commonSealroute/getCommonSealList/5cee33d225242e023acfb2d4",
      DATA: object
    }
    return this.httpService.post(registerList);
  }

  removecommonSealdetails(_id) {
    var request = {
      URL: "commonSeal/deleteCommonSealDetails/" + _id
    }
    return this.httpService.get(request);
  }

  getcommonSealDetailById(id) {
    var request = {
      URL: "commonSeal/getCommonSealDetail/" + id,
    }
    return this.httpService.get(request);
  }

  updateCommonSealDetail(object, id) {
    var request = {
      URL: "commonseal/updateCommonSealDetails/" + id,
      DATA: object
    }
    return this.httpService.post(request);
  }

  generateCommonSealDocument(object) {
    var request = {
      URL: "commonSeal/generateCommonSealDocument",
      DATA: object
    }
    return this.httpService.post(request);
  }

  downloadCommonSealFile(id, type) {
    var token = localStorage.getItem('token')
    window.location.href = environment.pssServerUrl + "commonSeal/downloadDocument/" + id + "/" + type + "/" + token;
  }
  downloadCommonSealPdfFile(id, type) {
    var token = localStorage.getItem('token')
    window.location.href = environment.pssServerUrl + "commonSeal/downloadPdfDocument/" + id + "/" + type + "/" + token;
  }
}

